import { useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import HighTensionLearning from "../HighTensionLearning/HighTensionLearning";
import LeaderboardHTLearning from "../LeaderboardHTLearning/LeaderboardHTLearning";
import Processing from "../../Components/Processing/Processing";
import "../TestingSession/TestingSession.css";
import "../DebugSession/DebugSession.css";

// Session shell for the HighTension guided learning module. Teacher (not
// joined) sees the live leaderboard; the student (or a joined teacher) runs the
// dictated exercise immediately. Mirrors HTTrainingSession.
const HTLearningSession = ({ data, socket, useStore } : { data: any, socket: any, useStore: any }) => {
    const { sessionId, join } = useParams();
    const joinNumber = useMemo(() => Number(join), []);
    const navigate = useNavigate();
    const location = useLocation();
    const sessionName = location?.state?.sessionName || window.history.state?.sessionName;

    const [initialState, setInitialState] = useState<string>("functiune");
    const [finalState, setFinalState] = useState<string>("ssv");
    const [cell, setCell] = useState<string>("");
    const [sessionIdx, setSessionIdx] = useState<number>(1);
    const [loaded, setLoaded] = useState<boolean>(false);
    const [entered, setEntered] = useState<boolean>(false);
    const times = useMemo(() => 0, []);
    const timesRef = useRef(times);

    // Owner = the table the session lives in. A student self-created session is
    // owned by the student (passed via navigation state); otherwise it's the
    // teacher's table.
    const ownerId = location?.state?.ownerId || window.history.state?.ownerId;
    const teacherId = ownerId || (data.userData.type === "teacher" ? data.userData.userId : data.userData.teacherId);

    const getJoinedSession = async () => {
        try {
            await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/session-htlearning/join-session-student-htlearning/${teacherId}/${data.userData.userId}/${sessionId}`, { headers: { "Content-Type": "application/json" } });
        } catch (e) { /* ignore */ }
        setEntered(true);
        timesRef.current++;
    };

    useLayoutEffect(() => {
        if (timesRef.current > 0) return;
        getJoinedSession().catch((err) => console.log(err));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        (async () => {
            try {
                const request = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/session-htlearning/check-id-htlearning/${teacherId}/${sessionId}`, { headers: { "Content-Type": "application/json" } });
                const response = await request.json();
                if (!response.success) return navigate(-1);
                // `scenario` column holds "initialState>finalState".
                const [ini, fin] = String(response.results?.scenario || "").split(">");
                setInitialState(ini || "functiune");
                setFinalState(fin || "ssv");
                setCell(response.results?.cell || "");
                setSessionIdx(response.sessionIdx || 1);
                setLoaded(true);
            } catch (e) { /* ignore */ }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (data.userData.type === "teacher" && !joinNumber) {
        return <LeaderboardHTLearning data={data} socket={socket} sessionName={sessionName} />;
    }

    if (entered && loaded) {
        return (
            <HighTensionLearning
                data={data}
                useStore={useStore}
                session={{
                    teacherId,
                    studentId: data.userData.userId,
                    sessionId: sessionId as string,
                    initialState,
                    finalState,
                    cell,
                    sessionIdx,
                    onFinish: () => navigate(`/session-htlearning/${sessionId}/leaderboard`, { state: { sessionName, ownerId: teacherId } }),
                }}
            />
        );
    }

    return <Processing />;
};

export default HTLearningSession;
